import React from 'react';
import { Form, Input } from 'antd';
import SectionHeader from '../../components/SectionHeader';
import InfoTip from '../../components/InfoTip';
import OptLabel from '../../components/OptLabel';
import NpiRegistryBox from '../../components/NpiRegistryBox';
import s from '../../s.module.less';

const normalizeNpi = (v?: string) => (v || '').replace(/\D/g, '').slice(0, 10);

// Step 1 — Billing provider。原型将 last name / organization name 合成一个字段，
// 以 RCM onboarding 接口为准拆成 lastName（必填）+ organizationName（可选）
export default function StepBillingProvider() {
    return (
        <div className={s.wizSection} data-wiz-section>
            <SectionHeader title="Name & NPI" />
            <div className={s.wizRow}>
                <Form.Item name={['billing', 'firstName']} label="Billing first name">
                    <Input size="large" placeholder="First name" />
                </Form.Item>
                <Form.Item name={['billing', 'lastName']} label="Billing last name">
                    <Input size="large" placeholder="Last name" />
                </Form.Item>
            </div>
            <Form.Item name={['billing', 'organizationName']} label={<OptLabel>Organization name</OptLabel>}>
                <Input size="large" placeholder="Organization name" />
            </Form.Item>
            <Form.Item
                name={['billing', 'npi']}
                label={
                    <span>
                        Billing NPI
                        <InfoTip title="Find your NPI at nppes.cms.hhs.gov" />
                    </span>
                }
                normalize={normalizeNpi}
            >
                <Input size="large" inputMode="numeric" maxLength={10} placeholder="10 digit NPI" />
            </Form.Item>
            <NpiRegistryBox
                allowManualTaxonomy
                ns={['billing']}
                typeHint={(t) =>
                    t === 'Type 2'
                        ? 'This NPI belongs to an organization, so claims carry the organization name only, no ' +
                          "first name. Each clinician's own individual NPI is collected in the Providers step."
                        : 'This NPI belongs to a person, so you are both the billing and the rendering provider. ' +
                          'Klarity reuses it in the Providers step instead of asking for a second NPI.'
                }
            />
        </div>
    );
}
